/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFoldUp = createReactComponent("outline", "fold-up", "IconFoldUp", [["path", { "d": "M12 13v-8l-3 3m6 0l-3 -3", "key": "svg-0" }], ["path", { "d": "M9 17l1 0", "key": "svg-1" }], ["path", { "d": "M14 17l1 0", "key": "svg-2" }], ["path", { "d": "M19 17l1 0", "key": "svg-3" }], ["path", { "d": "M4 17l1 0", "key": "svg-4" }]]);

export { IconFoldUp as default };
//# sourceMappingURL=IconFoldUp.mjs.map
